import {useState} from "react";

interface PromptDialogProps {
    title: string;
    placeholder?: string;
    existingNames?: string[];
    onConfirm(value: string): void;
    onCancel(): void;
}

function PromptDialog(props: PromptDialogProps) {
    const [value, setValue] = useState('');

    const trimmed = value.trim();
    const isDuplicate = trimmed !== '' && props.existingNames?.some(
        n => n.toLowerCase() === trimmed.toLowerCase()
    );
    const canConfirm = trimmed !== '' && !isDuplicate;

    return (
        <div className={'layout vertical overlay'} onClick={props.onCancel}>
            <div className={'layout vertical gap box'} style={{padding: 20, gap: 15, width: 350}}
                 onClick={e => e.stopPropagation()}>
                <p className={'text header'}>{props.title}</p>
                <input
                    autoFocus
                    placeholder={props.placeholder ?? 'Enter name...'}
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === 'Enter' && canConfirm) props.onConfirm(trimmed);
                        if (e.key === 'Escape') props.onCancel();
                    }}
                />
                <p style={{
                    color: '#ff6666', visibility: isDuplicate ? 'visible' : 'hidden',
                    border: 'none', background: 'none', padding: 0, margin: 0
                }}>
                    Already used!
                </p>
                <div className={'layout horizontal gap'} style={{justifyContent: 'flex-end'}}>
                    <button onClick={props.onCancel}
                            style={{backgroundColor: '#aa4444', color: 'white'}}>Cancel</button>
                    <button onClick={() => canConfirm && props.onConfirm(trimmed)}
                            disabled={!canConfirm}
                            style={{backgroundColor: canConfirm ? '#4a8a4a' : '#3a5a3a', color: 'white', opacity: canConfirm ? 1 : 0.5, pointerEvents: canConfirm ? 'auto' : 'none', cursor: canConfirm ? 'pointer' : 'default'}}>OK</button>
                </div>
            </div>
        </div>
    );
}

export default PromptDialog;
